module.exports = __webpack_public_path__ + "img/5.3156b416.jpg";